(function() {
  'use strict';

  /* jshint undef: true */
  /* global _:false */
  angular
    .module('linshare.anonymousUrl')
    .constant('_', _);
})();
